import React from 'react';

import { Container, ContainerProps } from './styles';

const BadgeAppointmentArea: React.FC<ContainerProps> = ({ type }) => {
  return <Container type={type} />;
};

export default BadgeAppointmentArea;
